// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + ".cf507b77c4ebb19ba2a772c9aab6264d.js";
};